import React from "react";

import { twMerge } from 'tailwind-merge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from './DataTable2';
import Pagination from "./Pagination";
import empty from "../assets/undraw_no_data_re_kwbl.svg";

interface PropTypes {
  data: any[];
  columns: { header: string; accessor: (item: any) => any, className?: string, cellClassName?: string }[];
  isFetching: boolean;
  emptyStateMessage: string;
  currentPage: number;
  setCurrentPage: any;
  totalPages: number;
  headerClassName?: string;
  className?: string
  height?: string
  rowClassName?: (item: any) => string
  onClick?: () => void
}

const DataTableView = ({
  className,
  height,
  data,
  columns,
  isFetching,
  emptyStateMessage,
  currentPage,
  setCurrentPage,
  totalPages,
  headerClassName,
  rowClassName,
  onClick
}: PropTypes) => {
  return (
    <>

      <div className='hidden md:block'>
        <Table className={className} height={height}>
          <TableHeader className={twMerge("sticky top-0 z-20 p-2 md:gap-3", headerClassName)}>
            <TableRow onClick={onClick}>

              {columns.map((column, index) => (
                <TableHead key={index} className={column.className} >
                  {column.header}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody className='z-0'>
            {isFetching ? (
              <TableRow>
                <TableCell colSpan={columns.length}>
                  <div className="min-h-[400px] w-full bg-white flex items-center justify-center rounded-lg">
                    <div className="loader"></div>
                  </div>
                </TableCell>
              </TableRow>
            ) : data?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length}>
                  <div className="w-full py-10 flex flex-col items-center justify-center">
                    <img className="w-1/6" src={empty} alt="No data found" />
                    <p className="mt-4 ml-14 text-lg text-gray-500 text-center">
                      {emptyStateMessage || "No Data Found"}
                    </p>
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              data?.map((row, rowIndex) => (
                <TableRow key={rowIndex} className={twMerge(" !border-b", rowClassName?.(row))}>
                  {columns.map((column, colIndex) => {
                    return (
                      <TableCell key={colIndex} className={twMerge('md:pl-5', columns.map((column) => { return column.cellClassName }))} >
                        {column.accessor(row) ?? "N/A"}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table >

        {!isFetching && data?.length > 0 && (
          <div className="mt-4">
            <Pagination
              currentPage={currentPage}
              page={totalPages}
              handlePageClick={(e: { selected: number }) =>
                setCurrentPage(e.selected + 1)
              }
            />
          </div>
        )}

      </div>

      <div className="h-full  flex flex-col justify-between w-full bg-transparent rounded-lg md:hidden">
        {isFetching ? (
          <div className="max-h-max w-full flex items-center justify-center py-6">
            <div className="loader"></div>
          </div>
        ) : data?.length === 0 ? (
          <div className="w-full py-10 h-full flex flex-col items-center justify-center">
            <img className="w-2/5" src={empty} alt="No data found" />
            <p className="mt-10 text-2xl text-gray-500 font-inter">
              {emptyStateMessage || "No Data Found"}
            </p>
          </div>
        ) : (
          <div className="space-y-4">
            {data?.map((item: any, rowIndex: number) => (
              <div
                key={rowIndex}
                className={twMerge("border  rounded-lg p-4 space-y-3 bg-white border-primary", rowClassName?.(item))}
              >
                {columns.map((column: any, colIndex: number) => (
                  <div key={colIndex} className={twMerge(`flex flex-row items-start ${column.header === "Actions" || column.header === "Service Type" ? "items-center" : ""}`)}>
                    <span className={twMerge(`text-[16px] text-black font-bold max-w-max `, column.headerClassName)}>
                      {column.header}:
                    </span>
                    <div className="ml-1 text-base text-gray-600 break-words whitespace-normal">
                      {column.accessor(item) ?? "N/A"}
                    </div>
                  </div>
                ))}
              </div>
            ))}


            {!isFetching && data?.length > 0 &&
              <div className="mt-6 self-end">
                <Pagination
                  currentPage={currentPage}
                  page={totalPages}
                  handlePageClick={(e: { selected: number }) =>
                    setCurrentPage(e.selected + 1)
                  }
                />
              </div>
            }

          </div>

        )}
      </div >

    </>
  );
};

export default DataTableView;
